module.exports = __webpack_public_path__ + "static/media/logo.526b940d.svg";